import React from 'react';
import { Head } from '@inertiajs/react';
import { Button } from '~/marketing/ui';
import { routes } from '~/marketing/routes';
import { withMarketingLayout } from '~/marketing/MarketingLayout';

/* One state for expired, tampered with, or superseded. Saying which would
   tell whoever holds the link something about someone else's report. */
export default function Expired() {
  return (
    <>
      <Head title="Report link">
        <meta name="robots" content="noindex, nofollow" />
        <meta name="referrer" content="no-referrer" />
      </Head>
      <main className="sp-page" style={{ paddingBlock: 'clamp(64px,9vw,128px)', display: 'grid', gap: 'var(--space-6)', maxWidth: 720, justifyItems: 'start' }}>
        <span className="sp-label">Report link</span>
        <h1 style={{ fontSize: 'var(--fs-h1)', lineHeight: 1.08 }}>This link doesn't open a report.</h1>
        <p style={{ color: 'var(--text-body)', margin: 0, maxWidth: '54ch' }}>If it came from an email we sent you, run the check again and we'll email you a new link.</p>
        <Button size="lg" href={routes.grader}>Check your visibility</Button>
      </main>
    </>
  );
}

Expired.layout = withMarketingLayout;
